import { mailchimp } from "./mailchimp";

var form_submitted = false;

function checkFormSubmission($mainForm) {
  mailchimp(".hidden-form form", function() {
    form_submitted = true;
    $mainForm.trigger("submit");
  });
}

$("#create_customer").on("submit", function(e) {
  let $this = $(this);
  let newsletterCheck = $this.find("#newsletter-check");
  let $pass = $this.find(".pass");
  let $passConfirm = $this.find(".password-confirm");

  if ($pass.val() !== $passConfirm.val() && $pass.val() != "") {
    e.preventDefault();
    $pass.add($passConfirm).addClass("error");
  } else {
    if (newsletterCheck.prop("checked") && !form_submitted) {
      e.preventDefault();
      checkFormSubmission($this);
      let $newsletterForm = $(".hidden-form form");
      let emailVal = $this.find('input[name="customer[email]"]').val();
      $newsletterForm.find('input[name="EMAIL"]').val(emailVal);
      $newsletterForm.find(".button").trigger("click");
    }
  }
});



// WEBPACK FOOTER //
// ../assets/js/account-login-register.js